import { SET_RP_RECIPIENT_DATA } from "../../redux/actions/action.types";

export default function setRPRecipientData(recData: any, stateHandler: any) {
  stateHandler({
    type: SET_RP_RECIPIENT_DATA,
    payload: recData,
  });
}
